import { USERS_PROFILE_OPTIONS } from '~/helpers/Users.const';
import { USER_PROFILE_TYPE_ENUM } from '~/enums/Users.enum';

export class Profile {
  constructor(
    readonly _name: string = '',
    readonly _lastName: string = '',
    readonly _groups: string[] = [],
    readonly _email: string = '',
    private _theme: 'dark' | 'light' = 'light',
  ) {}

  get name(): string {
    return this._name;
  }

  get lastName(): string {
    return this._lastName;
  }

  get fullName(): string {
    return `${this._name} ${this._lastName}`;
  }

  get initialLetters(): string {
    return `${this._name[0]}${this._lastName[0]}`;
  }

  get theme(): 'dark' | 'light' {
    return this._theme;
  }

  get isMaster(): boolean {
    return this._groups.includes(USER_PROFILE_TYPE_ENUM[1]);
  }
  get isCommercial(): boolean {
    return this._groups.includes(USER_PROFILE_TYPE_ENUM[2]);
  }
  get isManager(): boolean {
    return this._groups.includes(USER_PROFILE_TYPE_ENUM[3]);
  }
  get isFinancial(): boolean {
    return this._groups.includes(USER_PROFILE_TYPE_ENUM[4]);
  }
  get isFinancialAdmin(): boolean {
    return this._groups.includes(USER_PROFILE_TYPE_ENUM[5]);
  }

  get groupLabel(): string {
    if (this.isMaster) return USERS_PROFILE_OPTIONS[USER_PROFILE_TYPE_ENUM[1]];
    if (this.isManager) return USERS_PROFILE_OPTIONS[USER_PROFILE_TYPE_ENUM[3]];
    if (this.isFinancialAdmin) return USERS_PROFILE_OPTIONS[USER_PROFILE_TYPE_ENUM[5]];
    if (this.isFinancial) return USERS_PROFILE_OPTIONS[USER_PROFILE_TYPE_ENUM[4]];

    return USERS_PROFILE_OPTIONS[USER_PROFILE_TYPE_ENUM[2]];
  }

  setTheme(theme: 'dark' | 'light') {
    this._theme = theme;
  }
}
